module.exports = __webpack_public_path__ + "static/media/azys.2c6da218.jpg";